export { default as ReactMermaidComponent } from './mermaid.component'
